import { debounce } from 'lodash';
import { TIME_DEBOUNE_CALL_API } from 'shared/constants/http';

const debounceFunc = (func, timeCall = TIME_DEBOUNE_CALL_API) => {
  return debounce(func, timeCall);
};

export default debounceFunc;
